import { ResourceType } from '../../../typings/permissions';
import type { ReleaseGroupActions, ReleaseGroupAnyActions } from '../../../typings/permissions';

import useHasPermission from './useHasPermission';

/**
 * Helper hook for checking user's Release Group permissions.
 * @param releaseGroupId - The Release Group ID to check release permissions for.
 * @param action - The action to check for.
 * @returns Whether the user has the given permission for the given release group.
 */
const useHasReleaseGroupPermission = (
  releaseGroupId: number,
  action: ReleaseGroupActions | ReleaseGroupAnyActions,
): boolean => {
  const hasPermission = useHasPermission();

  return (
    hasPermission({
      resourceType: ResourceType.ReleaseGroupAny,
      action: action as ReleaseGroupAnyActions,
    }) ||
    hasPermission({
      resourceType: ResourceType.ReleaseGroup,
      action,
      releaseGroupId,
    })
  );
};

export default useHasReleaseGroupPermission;
